// Calendar action type for: Staff Leave List, StaffLeaveType
//StaffLEaveList
export const GET_STAFF_LEAVE_LIST = "GET_STAFF_LEAVE_LIST";
export const GET_STAFF_LEAVE_LIST_SUCCESS = "GET_STAFF_LEAVE_LIST_SUCCESS";
export const GET_STAFF_LEAVE_LIST_ERROR = "GET_STAFF_LEAVE_LIST_ERROR";

// Staff Leave Type
export const GET_STAFF_LEAVE_TYPE = "GET_STAFF_LEAVE_TYPE";
export const GET_STAFF_LEAVE_TYPE_SUCCESS = "GET_STAFF_LEAVE_TYPE_SUCCESS";
export const GET_STAFF_LEAVE_TYPE_ERROR = "GET_STAFF_LEAVE_TYPE_ERROR";
